export const footersection = [
  { Hostings: [
    "Minecraft Hosting",
    "Docker Hosting",
    "High Performance Hosting",
    "Database Hosting",
    "Web Hosting"
  ], },
  { Resources: [
    "Domain",
    "Email Service",
    "Object Storage",
    "Rest APIs",
    "IP Public"
  ],},
  { Network: [
    "Virtual Private Network",
    "Private IP Public",
    "Reverse Proxy",
    "Cloud Router"
  ],},
  {Company: [
    "Contact",
    "Email Support",
    "Whatsapp Support",
    "Terms of Service",
    "Privacy Policy"
  ]},
];
